import React from 'react';

function PhoneVerificationNudge({
  phone,
  verificationCode,
  onVerificationCodeChange,
  onVerifyCode,
  onResendVerification,
  resendCooldown,
  resending,
  onSkip
}) {
  return (
    <div className="modal-overlay">
      <div className="modal-content password-modal">
        <h2>Email Verified</h2>

        <p style={{ marginBottom: '1.5rem', color: 'var(--color-text-secondary)', fontSize: '0.875rem' }}>
          You're in. We also sent a code to <strong>{phone}</strong> to verify your phone number —
          this is optional and separate from your account access, so verify it now or skip and finish later in Settings.
        </p>

        <form onSubmit={onVerifyCode} className="profile-form" style={{ marginBottom: '1rem' }}>
          <div className="form-group">
            <label>Enter the code texted to {phone}</label>
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => onVerificationCodeChange(e.target.value)}
              required
              placeholder="Enter 6-digit code"
              maxLength="6"
              pattern="\d{6}"
              autoFocus
            />
          </div>

          <div className="modal-actions" style={{ marginBottom: 0 }}>
            <button type="submit" className="btn-primary">Verify Code</button>
            <button
              type="button"
              onClick={() => onResendVerification('sms')}
              disabled={resendCooldown > 0 || resending}
              className="btn-secondary"
            >
              {resending ? 'Sending...' : resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 'Resend Code'}
            </button>
          </div>
        </form>

        <div className="modal-actions">
          <button type="button" onClick={onSkip} className="btn-cancel">
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}

export default PhoneVerificationNudge;
